const data=[
    {
        "name":"Rice",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681634856/rice-bowl_1_aeehjk.png"
    },
 
    {
        "name":"Beans",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1682611722/red-beans_uckipl.png"
    },
    {
        "name":"Biryani(Non-Veg)",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643389/biryani_p8pbcf.png"
    },
    {
        "name":"Cheese",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643411/cheese_mu4vj5.png"
    },
    {
        "name":"Leg-Peice Chicken",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643485/chicken-leg_qmwbaz.png"
    },
    {
        "name":"Chocolate",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643485/chocolate-bar_udlvo9.png"
    },
    {
        "name":"Coconut",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643485/coconut_-_Copy_bzlpu7.png"
    },
    {
        "name":"Chana(ChickPeas)",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643485/chole_-_Copy_xv6vvs.png"
    },
    {
        "name":"Dosa",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/dosa_w7tjyh.png"
    },
    {
        "name":"Idli",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1682611722/mochi_jutdln.png"
    },
    {
        "name":"Tuna",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/fish_zgpqaa.png"
    },
    {
        "name":"Cucumber",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/cucumber_-_Copy_euoerw.png"
    },
    {
        "name":"Atta",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/flour_wxjcbi.png"
    },
    {
        "name":"Dry Fruits",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/dried-fruits_jro3b5.png"
    },
    {
        "name":"Eggs",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643486/fried-egg_bklaj8.png"
    },
   
    {
        "name":"Grapes",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/grape_qdatqy.png"
    },
    {
        "name":"Mango",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/mango_k4gzuq.png"
    },
    {
        "name":"Banana",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643286/banana_dtrh9o.png"
    }, 
    {
        "name":"Apple",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643211/apple_vemjkv.png"
    },
    {
        "name":"Mushrooms",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/mushroom_si6nkk.png"
    },
    {
        "name":"Milk",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/milk_ummoav.png"
    },
    {
        "name":"Pear",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/pear_qmjdak.png"
    },
    {
        "name":"Peach",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/peach_hcj7ik.png"
    },
    {
        "name":"Potato",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/potato_maaio1.png"
    },
    {
        "name":"Onion",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643487/onion_bp9ng9.png"
    },
    {
        "name":"Tomato",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1682611722/tomato_x8whec.png"
    },
    {
        "name":"Salmon",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1682611722/fish_cigylx.png"
    },
    {
        "name":"Sweet Potato",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643488/sweet-potato_ex7etb.png"
    },
    {
        "name":"Brown Bread",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643488/toast_wgs0r8.png"
    },
    {
        "name":"White Bread",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643489/white-bread_ktq9it.png"
    },
    {
        "name":"Yogurt",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643489/yogurt_rdwpo5.png"
    },
    {
        "name":"Paneer",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643488/tofu_n4oe1t.png"
    },
    {
        "name":"Whey Protein",
        "image":"https://res.cloudinary.com/dejvlvhlp/image/upload/v1681643488/whey-protein_molhuw.png"
    },
]

export default data;

